<template>
    <div class="organize">
        <TitlePart text="Organizations"/>
        <a-row :gutter="[24,24]" class="myrow">
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/ica_logo.png" alt="">
                </div>
            </a-col>
            <a-col :xs="12" :sm="8" :lg="5">
                <div class="logo-box">
                    <img src="@/assets/organizers/PolyU Logo_RGB-removebg.png" alt="">
                </div>
            </a-col>
            
        </a-row>
    </div>
</template>

<script>
import TitlePart from '@/components/TitlePart/TitlePart.vue'
    export default {
        components:{
            TitlePart
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>